export default __webpack_public_path__ + "static/media/cloud.0a1a6c63.jpg";